<template>
  <Flex direction="column" :gap="16">
    <Text size="text-md" color="color-text-text-secondary-700" weight="semibold">
      Zaznacz elementy, które chcesz uwzględnić na PDF
    </Text>
    <Flex direction="column" :gap="12">
      <Checkbox
        :model-value="anyShoppingList"
        :disabled="!enabled"
        label="Lista zakupów"
        size="sm"
        @update:model-value="toggleShoppingLists"
      />
      <Flex direction="column" :gap="8" :padding-x="24">
        <Checkbox
          size="sm"
          :disabled="!enabled"
          label="Zbiorcza lista dla całego jadłospisu"
          :model-value="options.showConsolidatedShoppingList"
          @update:model-value="emit('option', 'showConsolidatedShoppingList', $event)"
        />
        <Checkbox
          :disabled="!enabled || options.groupBy === 'meals'"
          size="sm"
          label="Oddzielna lista dla każdego tygodnia"
          :model-value="options.showShoppingList"
          @update:model-value="emit('option', 'showShoppingList', $event)"
        />
      </Flex>
      <Checkbox
        size="sm"
        :model-value="options.showWeek"
        :disabled="!enabled"
        label="Podsumowanie każdego tygodnia"
        @update:model-value="emit('option', 'showWeek', $event)"
      />
      <Checkbox
        size="sm"
        :model-value="options.showComments"
        :disabled="!enabled"
        label="Komentarze do jadłospisu"
        @update:model-value="emit('option', 'showComments', $event)"
      />
      <Tooltip>
        <template #trigger>
          <Checkbox
            size="sm"
            :disabled="!enabled"
            label="Wartości odżywcze"
            :model-value="options.showNutrients"
            @update:model-value="emit('option', 'showNutrients', $event)"
          />
        </template>
        Możesz wybrać Wartości odżywcze lub Najważniejsze składniki odżywcze.
      </Tooltip>
      <Tooltip>
        <template #trigger>
          <Checkbox
            size="sm"
            :model-value="options.showChosenNutrients"
            :disabled="!enabled"
            label="Najważniejsze składniki odżywcze"
            @update:model-value="emit('option', 'showChosenNutrients', $event)"
          />
        </template>
        Możesz wybrać Wartości odżywcze lub Najważniejsze składniki odżywcze.
      </Tooltip>
      <Checkbox
        size="sm"
        :model-value="options.showMealHour"
        :disabled="!enabled"
        label="Godziny posiłków"
        @update:model-value="emit('option', 'showMealHour', $event)"
      />
      <Checkbox
        size="sm"
        :model-value="options.showPreparationTime"
        :disabled="!enabled"
        label="Czas przygotowania posiłków"
        @update:model-value="emit('option', 'showPreparationTime', $event)"
      />
      <Checkbox
        size="sm"
        :model-value="options.printInevitableLosses"
        :disabled="!enabled || !lossesActive"
        label="Straty talerzowe"
        @update:model-value="emit('option', 'printInevitableLosses', $event)"
      />
      <Checkbox
        size="sm"
        :model-value="options.showQRCodes"
        :disabled="!enabled"
        label="Strona zachęcająca do pobrania aplikacji mobilnej"
        @update:model-value="emit('option', 'showQRCodes', $event)"
      />
      <Checkbox
        size="sm"
        :model-value="options.showKcalmarLogo"
        :disabled="!enabled || !canDisableFooter"
        label="Stopka Kcalmar na każdej stronie"
        @update:model-value="emit('option', 'showKcalmarLogo', $event)"
      />
    </Flex>
  </Flex>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  import { Checkbox, Tooltip } from '@/components/ui'
  import Flex from '@/components/ui/Flex/Flex.vue'
  import Text from '@/components/ui/Text/Text.vue'

  import type { PrintOptions } from '../../types'

  const props = defineProps<{
    canDisableFooter: boolean
    enabled: boolean
    lossesActive: boolean
    options: PrintOptions
  }>()
  const emit = defineEmits<{
    option: [key: keyof PrintOptions, value: boolean]
  }>()

  const anyShoppingList = computed(
    () => props.options.showConsolidatedShoppingList || props.options.showShoppingList,
  )

  const toggleShoppingLists = (value: boolean) => {
    emit('option', 'showConsolidatedShoppingList', value)
    if (props.options.groupBy === 'days') emit('option', 'showShoppingList', value)
  }
</script>

<style scoped>
  .content-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .content-options h3 {
    margin: 0 0 4px;
    font-size: 14px;
  }

  .content-options__nested {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-left: 24px;
  }
</style>
